'use client';

import { Button } from '@common/components';

import { CustomLink } from '@/app/_components/CustomLink';
import { DONATION_ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
import { useHistoryStore } from '@/stores/HistoryStore/useHistoryStore';

const DonateButton = () => {
  const router = useCustomRouter();

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      return;
    }

    event.preventDefault();

    const { historyIndex, customHistory } = useHistoryStore.getState();
    const previousPathname = customHistory.get(historyIndex - 1)?.split('?')[0];

    //* 홈에서 들어온 경우 push하면 홈 → 가이드 → 홈이 쌓여 뒤로가기가 가이드로 돌아온다
    if (previousPathname === DONATION_ROUTES.HOME.pathname) {
      router.back();

      return;
    }

    router.replace(DONATION_ROUTES.HOME.pathname);
  };

  return (
    <Button asChild className="w-full">
      <CustomLink
        href={DONATION_ROUTES.HOME.pathname}
        aria-label="고향사랑기부 홈으로 이동"
        onClick={handleClick}
      >
        기부하러 가기
      </CustomLink>
    </Button>
  );
};

export default DonateButton;
